"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductUnitOfMeasureSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class ProductUnitOfMeasureSearchResponse extends common_1.PaginatedResponse {
}
exports.ProductUnitOfMeasureSearchResponse = ProductUnitOfMeasureSearchResponse;
//# sourceMappingURL=product-unit-of-measure-search.response.js.map